var exports = {
  "iU": "Message.module__message___VVB5bH",
  "Ph": "Message.module__messagePreviewSpacing___VVB5bH",
  "IL": "Message.module__messagePreview___VVB5bH",
  "Xo": "Message.module__messageHovered___VVB5bH",
  "uK": "Message.module__focusRingAnchor___VVB5bH",
  "J8": "Message.module__messageCompact___VVB5bH",
  "L8": "Message.module__messageMentioned___VVB5bH",
  "m6": "Message.module__messageReplying___VVB5bH",
  "O6": "Message.module__messageHighlight___VVB5bH",
  "lY": "Message.module__contextMenuActive___VVB5bH",
  "Bc": "Message.module__mobileLayout___VVB5bH",
  "p2": "Message.module__messageLongPress___VVB5bH",
  "Uw": "Message.module__messageGrouped___VVB5bH",
  "kT": "Message.module__messageEditing___VVB5bH",
  "E4": "Message.module__messageSent___VVB5bH",
  "mr": "Message.module__messageSending___VVB5bH",
  "b$": "Message.module__messageFailed___VVB5bH",
  "RZ": "Message.module__failedFooter___VVB5bH",
  "Iu": "Message.module__failedFooterMessage___VVB5bH",
  "bg": "Message.module__failedFooterLabel___VVB5bH",
  "OZ": "Message.module__failedFooterIcon___VVB5bH",
  "dv": "Message.module__failedRetryIcon___VVB5bH",
  "QW": "Message.module__failedRetryButton___VVB5bH",
  "q5": "Message.module__messageGutterLeft___VVB5bH",
  "ZN": "Message.module__messageGutterRight___VVB5bH",
  "$7": "Message.module__messageAvatar___VVB5bH",
  "CW": "Message.module__messageNoText___VVB5bH",
  "U7": "Message.module__messageContent___VVB5bH",
  "rO": "Message.module__messageAuthorInfo___VVB5bH",
  "xW": "Message.module__jumpHeading___VVB5bH",
  "RO": "Message.module__jumpHeadingButton___VVB5bH",
  "dw": "Message.module__messageAuthorRow___VVB5bH",
  "AY": "Message.module__messageAuthorPart___VVB5bH",
  "x": "Message.module__userTagOffset___VVB5bH",
  "oL": "Message.module__messageTimestamp___VVB5bH",
  "BK": "Message.module__authorDashSeparator___VVB5bH",
  "um": "Message.module__messageUsername___VVB5bH",
  "Lo": "Message.module__messageText___VVB5bH",
  "L5": "Message.module__messageTimestampCompact___VVB5bH",
  "tQ": "Message.module__compactAuthorPrefix___VVB5bH",
  "U6": "Message.module__copyOnly___VVB5bH",
  "Mz": "Message.module__compactInlineContent___VVB5bH",
  "aM": "Message.module__systemMessageContent___VVB5bH",
  "vp": "Message.module__contextMenuUnderline___VVB5bH",
  "aE": "Message.module__messageTimeoutIndicator___VVB5bH",
  "t4": "Message.module__textSeparator___VVB5bH",
  "KL": "Message.module__messageTimestampHover___VVB5bH",
  "jh": "Message.module__messageTimestampCompactHover___VVB5bH",
  "iZ": "Message.module__messageAvatarCompact___VVB5bH",
  "kq": "Message.module__compactContentWrapper___VVB5bH",
  "xv": "Message.module__hoverAction___VVB5bH",
  "kL": "Message.module__container___VVB5bH",
  "tI": "Message.module__repliedMessage___VVB5bH",
  "_T": "Message.module__repliedMessageCompact___VVB5bH",
  "$y": "Message.module__repliedTextPreview___VVB5bH",
  "NL": "Message.module__repliedAvatar___VVB5bH",
  "a3": "Message.module__repliedIconContainer___VVB5bH",
  "Pq": "Message.module__repliedIcon___VVB5bH",
  "EK": "Message.module__repliedUsername___VVB5bH",
  "IQ": "Message.module__repliedItalic___VVB5bH",
  "t": "Message.module__unstyled___VVB5bH",
  "Io": "Message.module__repliedTextContent___VVB5bH",
  "c": "Message.module__systemMessageFollowsSystem___VVB5bH",
  "Hj": "Message.module__systemMessageIconWrapper___VVB5bH",
  "Po": "Message.module__systemMessageIconCompact___VVB5bH",
  "jJ": "Message.module__systemMessageTimestamp___VVB5bH",
  "rc": "Message.module__systemMessageContentWrapper___VVB5bH",
  "V_": "Message.module__systemMessageCompactContent___VVB5bH",
  "Gq": "Message.module__systemMessageIconSvg___VVB5bH",
  "hr": "Message.module__systemMessageLink___VVB5bH",
  "ll": "Message.module__userTagCompact___VVB5bH",
  "O4": "Message.module__editedTimestamp___VVB5bH",
  "k8": "Message.module__editedLabel___VVB5bH",
  "zX": "Message.module__typingContainer___VVB5bH",
  "Y9": "Message.module__typingCluster___VVB5bH",
  "RL": "Message.module__typingIndicator___VVB5bH",
  "Kl": "Message.module__typingAvatarContainer___VVB5bH",
  "tY": "Message.module__typingText___VVB5bH",
  "AZ": "Message.module__typingClusterComposerStatus___VVB5bH",
  "am": "Message.module__compactContentNoPrefix___VVB5bH",
  "Ys": "Message.module__compactBody___VVB5bH",
  "Ac": "Message.module__unknownMessageCompactContent___VVB5bH",
  "qU": "Message.module__unknownMessageWarning___VVB5bH",
  "NG": "Message.module__keyboardFocused___VVB5bH",
  "an": "Message.module__messageClientSystem___VVB5bH",
  "og": "Message.module__systemMessageContainer___VVB5bH",
  "Is": "Message.module__systemMessageIcon___VVB5bH",
  "ry": "Message.module__mediaFocusRing___VVB5bH",
  "xS": "Message.module__systemMessageDismissButton___VVB5bH",
  "Eu": "Message.module__silentMessageIcon___VVB5bH",
};

module.exports = exports;
